import React, { useEffect, useState } from "react";
import { ListGroup } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import AssignGender from "./AssignGender";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AssignSubjectSchemaLists = () => {
  const [schemaList, setSchemaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [schemaId, setSchemaId] = useState("");
  const [derivationData, setDerivationData] = useState("");
  const [derivationLoader, setDerivationLoader] = useState(false);
  let { studyId } = useParams();

  const getEventFormSchema = async () => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setSchemaList(data?.data || []);
    setLoading(false);
  };

  const getAssignedGenderinSchema = async () => {
    setDerivationLoader(true);
    let data =
      await await studyEventFormSchemaServices.getAssignedGenderinSchema(
        studyId,
        schemaId
      );
    setDerivationData(data?.data || "");
    setDerivationLoader(false);
  };

  useEffect(() => {
    getEventFormSchema();
  }, [studyId]);

  useEffect(() => {
    if (schemaId && studyId) {
      getAssignedGenderinSchema();
    }
  }, [schemaId, studyId]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        className="position-relative"
        style={{ height: "calc(100vh - 100px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : schemaList?.length === 0 ? (
          <NoDataFoundTable MSG={"List not found!"} />
        ) : (
          <div className="p-2">
            <ListGroup>
              {schemaList?.map((schema, index) => (
                <ListGroup.Item
                  action
                  title={schema?.schemaName}
                  onClick={() => {
                    setSchemaId(schema?.schemaId);
                  }}
                  key={index}
                  style={{ padding: "7px 0px 7px 10px" }}
                  className={`hstack ${
                    schemaId === schema?.schemaId ? "selectedMenu" : "bg-white"
                  }`}
                >
                  <span>{schema?.schemaName}</span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        {derivationLoader ? (
          <PageLoader />
        ) : !schemaId ? (
          <NoDataFoundTable MSG={"Click to view Event Form Field!"} />
        ) : (
          schemaId && (
            <AssignGender
              schemaId={schemaId}
              studyId={studyId}
              derivationData={derivationData}
              getAssignedGenderinSchema={getAssignedGenderinSchema}
            />
          )
        )}
      </SplitPane>
    </>
  );
};

export default AssignSubjectSchemaLists;
